import { render, staticRenderFns } from "./TpTiga.vue?vue&type=template&id=67dbc3e6&"
import script from "./TpTiga.vue?vue&type=script&lang=js&"
export * from "./TpTiga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports